var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'dhtmlNumber';

var	DEFAULTS = {
	minValue				:	null,
	maxValue				:	null,
	defaultValue			:	1,
	step					:	1,
	wrapperAdd				:	true,
	wrapperClass			:	'',
	changeTimeout			:	500,
	changeEvent				:	'DHTML_NUMBER_CHANGE_PERFORMED'
};

/**
 * constructor
 * @param selector
 * @param options
 * @constructor
 */
var DhtmlNumber = function (selector, options) {
	this.$t = $(selector);
	this.$wrapper = null;

	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;

	this.initialise_();
};

/**
 * init funkce, nastavení potřebných proměnných a spuštění render a obslužných funkcí
 * @private
 */
DhtmlNumber.prototype.initialise_ = function() {
	// vypnutí našeptávače
	this.$t.attr('autocomplete', 'off');

	this.changeTimeout = null;

	// obalit spanem, kvůli případnému stylování šipek
	this.$wrapper = this.createWrapper_();

	// nastavení proměnných z data atributů
	this.minValue 		=  this.$t.data('min') || this.options.minValue;
	this.maxValue 		=  this.$t.data('max') || this.options.maxValue;
	this.defaultValue 	=  (this.$t.val() || this.$t.data('default')) || this.options.defaultValue;
	this.step 			=  this.$t.data('step') || this.options.step;

	// set initial value, if not in value
	this.$t.val(this.defaultValue);

	// render controls and handles them
	this.renderControls_();
	this.bindEvents_();
};

/**
 * vytvoří wrapper kolem inputu, aby bylo možné jednoduše nastylovat spinner
 * @returns {*}
 * @private
 */
DhtmlNumber.prototype.createWrapper_ = function() {
	var $wrapper = null;

	if(!this.options.wrapperAdd) return null;

	this.$t.wrap('<span></span>');
	$wrapper = this.$t.parents('span');
	$wrapper.addClass(this.options.wrapperClass);

	return $wrapper;
};

/**
 * renders controls for increasing and decreasing value
 * @private
 */
DhtmlNumber.prototype.renderControls_ = function() {
	var $controlsWrapper = $('<span class="dhtml-number-controls-group"></span>').appendTo(this.$wrapper);
	this.$decrease = $('<a href="javascript:void(0)" class="decrease" title="−">−</a>').appendTo($controlsWrapper);
	this.$increase = $('<a href="javascript:void(0)" class="increase" title="+">+</a>').appendTo($controlsWrapper);
};

DhtmlNumber.prototype.bindEvents_ = function() {
	var self_ = this;

	// click plus
	this.$increase.on('click', function(e) {
		var val = parseFloat(self_.$t.val());
		if(isNaN(val)) {
			val = self_.step;
		}
		val += self_.step;
		val = (self_.maxValue != null && val > self_.maxValue) ? self_.maxValue : val;

		val = self_.roundByDecimals_(val);
		self_.$t.val(val);

		self_.performChange_();
	});

	// click minus
	this.$decrease.on('click', function(e) {
		var val = parseFloat(self_.$t.val());
		if(isNaN(val)) {
			val = self_.step;
		}
		val -= self_.step;
		val = (self_.minValue != null && val < self_.minValue) ? self_.minValue: val;

		val = self_.roundByDecimals_(val);
		self_.$t.val(val);

		self_.performChange_();
	});

	// store old valid value first
	var oldValidValue = null;
	this.$t.on('keydown', function(e) {
		if (!isNaN($(e.currentTarget).val())){
			oldValidValue = $(e.currentTarget).val();
		}
	});

	// do validity checks and store new value
	this.$t.on('keyup', function(e) {

		var val = $(e.currentTarget).val();
		val = val.replace(",",".");
		$(e.currentTarget).val(val);

		if (val != '-' && isNaN(val)) {
			$(e.currentTarget).val(oldValidValue);
		}

		if (val != '-' && val !='' && self_.maxValue != null && val > self_.maxValue) {
			self_.$t.val(self_.maxValue);
		}
		if (val != '-' && val !="" && self_.minValue != null && val < self_.minValue) {
			self_.$t.val(self_.minValue);
		}

		self_.performChange_();
	});
};

/* zaokrouhlování */
DhtmlNumber.prototype.roundByDecimals_ = function(num) {
	var s = String(this.step);
	var len= 0;
	if (s.indexOf(".") > -1) {
		len = s.substring(s.indexOf(".")+1, s.length).length;
	}
	return num.toFixed(len);
};

/**
 * trigger change
 * @private
 */
DhtmlNumber.prototype.performChange_ = function() {
	var self_  = this;
	clearTimeout(this.changeTimeout);
	this.changeTimeout = setTimeout(function() {
		self_.$t.trigger(self_.options.changeEvent, [{
			input: self_.$t,
			instance: self_
		}]);
	}, this.options.changeTimeout);
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new DhtmlNumber(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/jquery.dhtmlnumber.js